import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: ['DV_DP_trailer__AV'] as const,
}
